const topics = [
  { icon: 'ri-fire-fill', iconColor: 'text-accent-400', label: '动作大片', desc: '肾上腺素飙升的硬核爽片', count: '128部' },
  { icon: 'ri-ghost-fill', iconColor: 'text-secondary-400', label: '悬疑惊悚', desc: '烧脑反转，深夜不敢独自看', count: '96部' },
  { icon: 'ri-rocket-fill', iconColor: 'text-primary-400', label: '科幻巨制', desc: '视觉奇观与未来想象', count: '84部' },
  { icon: 'ri-emotion-happy-fill', iconColor: 'text-primary-400', label: '喜剧合家欢', desc: '笑到停不下来的欢乐时光', count: '112部' },
  { icon: 'ri-heart-fill', iconColor: 'text-accent-400', label: '爱情文艺', desc: '心动瞬间与细腻情感', count: '73部' },
  { icon: 'ri-links-fill', iconColor: 'text-secondary-400', label: '动画乐园', desc: '全年龄段视觉盛宴', count: '65部' },
  { icon: 'ri-camera-fill', iconColor: 'text-foreground-400', label: '纪录纪实', desc: '真实故事的力量', count: '41部' },
  { icon: 'ri-moon-fill', iconColor: 'text-accent-400', label: '恐怖之夜', desc: '胆量考验，深夜专属体验', count: '58部' },
];

export default function SectionIndex() {
  return (
    <section id="index" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500/10 border border-accent-500/20 mb-4">
            <span className="w-3 h-3 flex items-center justify-center"><i className="ri-compass-3-fill text-accent-400 text-xs"></i></span>
            <span className="text-xs text-accent-400 font-medium whitespace-nowrap">类型探索</span>
          </div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-50 mb-2">深夜专题</h2>
          <p className="text-sm text-foreground-400 max-w-lg mx-auto">按类型探索你的深夜专属片单，总有一部让你不舍入眠</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {topics.map((item) => (
            <a
              key={item.label}
              href="#index"
              className="group flex flex-col items-center text-center p-4 md:p-5 rounded-lg bg-background-50 hover:bg-background-200/60 transition-colors cursor-pointer border border-background-200/50 hover:border-primary-500/30"
            >
              <span className={`w-10 h-10 flex items-center justify-center mb-3 rounded-full bg-background-200 group-hover:scale-110 transition-transform`}>
                <i className={`${item.icon} ${item.iconColor} text-lg`}></i>
              </span>
              <h3 className="text-sm md:text-base font-medium text-foreground-100 mb-1 whitespace-nowrap">{item.label}</h3>
              <p className="text-xs text-foreground-400 mb-2">{item.desc}</p>
              <span className="text-xs text-primary-400">{item.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}